import { z } from "zod";

export const emailPasswordSchema = z.object({
  email: z.string().email("올바른 이메일 형식이 아닙니다."),
  password: z.string().min(1, "비밀번호를 입력해주세요."),
});

// 통합 스키마 (모든 필드 포함)
export const combinedSchema = z.object({
  email: z.string().optional(),
  password: z.string(),
  newPassword: z.string(),
  confirmNewPassword: z.string().optional(),
  agreeTerms: z.boolean(),
  agreePrivacy: z.boolean(),
});

export type CombinedFormData = z.infer<typeof combinedSchema>;
